import { render } from "./MbTicketUrl.vue?vue&type=template&id=953f72b0&scoped=true"
import script from "./MbTicketUrl.vue?vue&type=script&lang=js"
export * from "./MbTicketUrl.vue?vue&type=script&lang=js"

import "./MbTicketUrl.vue?vue&type=style&index=0&id=953f72b0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-953f72b0"

export default script